import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CircularLoading from '../components/CircularLoading';

function RootRedirect() {
    const auth = useSelector(state => state.auth);
    const [checkedAuth, setCheckedAuth] = useState(false);

    useEffect(() => {
        if (auth.profile && auth.profile.uid) {
            setCheckedAuth(true);
        }
        if (auth.error && auth.error.msg && !auth.profile) {
            setCheckedAuth(true);
        }
    }, [auth.profile, auth.error]);

    if (!checkedAuth) {
        return <CircularLoading />;
    }

    if (auth.profile && auth.profile.uid) {
        const role = auth.profile.usertype;
        if (role === 'admin' || role === 'fleetadmin') {
            return <Navigate to="/dashboard" replace />;
        }
        if (role === 'driver') {
            return <Navigate to="/bookings" replace />;
        }
        if (role === 'customer') {
            return <Navigate to="/bookings" replace />;
        }
        return <Navigate to="/login" replace />;
    }

    return <Navigate to="/login" replace />;
}

export default RootRedirect;
